import React from 'react';
import Loader from './Loader';

export default function MuiLoader(props: any) {
  return <Loader message={props.message} />;
}
